import { render } from "./bmTopicCheck.vue?vue&type=template&id=0fc0b8f4&scoped=true"
import script from "./bmTopicCheck.vue?vue&type=script&lang=js"
export * from "./bmTopicCheck.vue?vue&type=script&lang=js"

import "./bmTopicCheck.vue?vue&type=style&index=0&id=0fc0b8f4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc0b8f4"]])

export default __exports__